import { render, staticRenderFns } from "./MicrolearningVideoActionsBar.vue?vue&type=template&id=60334336&scoped=true"
import script from "./MicrolearningVideoActionsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MicrolearningVideoActionsBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MicrolearningVideoActionsBar.vue?vue&type=style&index=0&id=60334336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60334336",
  null
  
)

export default component.exports